import Phaser from 'phaser';
import { Player } from '../entities/Player';

/**
 * SpectatorSystem - Handles camera following for dead players
 */
export class SpectatorSystem {
    private scene: Phaser.Scene;
    private spectatingPlayer?: Player;
    private spectatorLabel?: Phaser.GameObjects.Text;
    private isSpectating: boolean = false;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }

    startSpectating(player: Player, playerName: string): void {
        this.isSpectating = true;
        this.spectatingPlayer = player;

        // Camera follows this player
        this.scene.cameras.main.startFollow(player, true, 0.1, 0.1);

        // Show label
        if (this.spectatorLabel) this.spectatorLabel.destroy();

        this.spectatorLabel = this.scene.add.text(
            this.scene.cameras.main.centerX,
            this.scene.cameras.main.height - 40,
            `SPECTATING: ${playerName}`,
            {
                fontSize: '18px',
                fontFamily: 'Arial Black',
                color: '#ffffff',
                backgroundColor: '#00000080',
                padding: { x: 10, y: 5 }
            }
        ).setOrigin(0.5).setScrollFactor(0).setDepth(1000);
    }

    switchTo(player: Player, playerName: string): void {
        this.spectatingPlayer = player;
        this.scene.cameras.main.startFollow(player, true, 0.1, 0.1);
        if (this.spectatorLabel) {
            this.spectatorLabel.setText(`SPECTATING: ${playerName}`);
        }
    }

    stopSpectating(): void {
        this.isSpectating = false;
        this.spectatingPlayer = undefined;
        this.scene.cameras.main.stopFollow();
        this.spectatorLabel?.destroy();
        this.spectatorLabel = undefined;
    }

    isActive(): boolean {
        return this.isSpectating;
    }
}
